import { createContext, ReactNode } from "react";
import NoPermissionsPage from "views/NoPermissionsPage";
import { useUserRolePermissionStore } from "./RootStore.context";
import { observer } from "mobx-react";
import LoadingScreen from "components/Loading/LoadingScreen";


const PermissionContext = createContext<boolean>(false)

type PermissionsProviderProps = {
  children: ReactNode
}

export const PermissionsProvider = observer((props: PermissionsProviderProps) => {

  const { loading, haveAccessToPortal, canViewAssets, canViewUsers } = useUserRolePermissionStore()

  const isConfig = window.location.pathname.includes('/config')

  if (loading) {
    return <LoadingScreen />
  }

  if (!isConfig && !haveAccessToPortal) {
    return <NoPermissionsPage />
  }
  if (!isConfig && !canViewAssets && !canViewUsers) {
    return <NoPermissionsPage />
  }

  return <PermissionContext.Provider value={true}>{props.children}</PermissionContext.Provider>;
})